import { SZ_CLAIM_PAGE_INDICES } from '../../../actions/sizotsaFuneralClaim/types';
import {
    navigateToClaimentDetails,
    navigateToDeceasedDetails,
    navigateToUploadDocuments,
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToSuccessPage,
} from '../../../actions/sizotsaFuneralClaim/routing';

import { getActivePageIndex } from '../../../selectors/sizotsaFuneralClaim/routing';
import { getClaimentDetailsValid } from '../../../selectors/sizotsaFuneralClaim/claimentDetails';
import { performClaimentDetailsValidation } from './claimentDetails';
import { getDeceasedDetailsValid } from '../../../selectors/sizotsaFuneralClaim/deceasedDetails';
import { performDeceasedDetailsValidation } from './deceasedDetails';
import { getUploadDocumentsValid } from '../../../selectors/sizotsaFuneralClaim/uploadDocuments';
import { performUploadDocumentsValidation } from './uploadDocuments';
import { sendEmail, sendUploadDocument, setRefNumber } from '../../../actions/sizotsaFuneralClaim/referenceData';
export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) {
        return next(action);
    }

    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);

    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);

    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case SZ_CLAIM_PAGE_INDICES.CLAIMENT_DETAILS:
            !getClaimentDetailsValid(state)
              ? performClaimentDetailsValidation(store)
              :
            store.dispatch(navigateToDeceasedDetails());
            break;

        case SZ_CLAIM_PAGE_INDICES.DECEASED_DETAILS:
            !getDeceasedDetailsValid(state)
              ? performDeceasedDetailsValidation(store)
              :
            store.dispatch(navigateToUploadDocuments());
            break;
        case SZ_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS:
            if(!getUploadDocumentsValid(state)){
                performUploadDocumentsValidation(store)
            } else {
                const buyRef = Math.floor(100000000000 + Math.random() * 900000000000);
                store.dispatch(setRefNumber(buyRef))
                // store.dispatch(navigateToSuccessPage());
                store.dispatch(sendEmail(buyRef));
                store.dispatch(sendUploadDocument())
            }
            
            break;

        case SZ_CLAIM_PAGE_INDICES.SUCCESS_PAGE:
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case SZ_CLAIM_PAGE_INDICES.DECEASED_DETAILS:
            store.dispatch(navigateToClaimentDetails());
            break;

        case SZ_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS:
            store.dispatch(navigateToDeceasedDetails());
            break;
    }
};
